import styled from "styled-components";

export const SideNavBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 15%;
`;
export const LogoBox = styled.div`
  height: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .logo_img_box {
    max-height: 85px;
    height: 45px;
    width: 65%;
    max-width: 65%;
    overflow: hidden;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
export const MenuContainer = styled.div``;
